import Dialog from "../../../1. Core/Controls/Dialog/Dialog";
import TextField from "../../../1. Core/Controls/TextField/TextField";
import NP from "../../../1. Core/NP";
import {getTournaments, ITournament} from "../../Util";
import {EventTournament, FighterStatWidgetMetadata, IAthlete, SportType, Widget} from "../../types";
import {ServerAPI} from "../../../1. Core/ServerAPI";
import {WidgetType} from "../WEnum";
import SelectFighterCtrl from "../../../2. Athletes/SelectFighterCtrl";
import Select from "../../../1. Core/Controls/Select/Select";
import ColorPicker from "../../../1. Core/Controls/ColorPicker/ColorPicker";


export default class FighterStatWidgetEditDialog extends Dialog {
	private _name: TextField;

	private _backgoundUrlInput: TextField;

	private _eventCombo: Select;
	private _tournamentCombo: Select;

	private _Widget: Widget<FighterStatWidgetMetadata>;

	private _previewFrame: HTMLFrameElement;
	private _timeId: any;
	private _tEvents: EventTournament[];
	private _leftTopLogoUrlInput: TextField;
	private _logoRightBottomLogoUrlInput: TextField;
	private _photoUrlInput: TextField;
	private _fighterNameInput: TextField;
	private _selectFighter: SelectFighterCtrl;
	private _periodType: Select;
	private _fontCombo: Select;
	private _fontColor: ColorPicker;
	private _SelectedAthlete: IAthlete;

	_initFields(settings: object)
	{
		this._Widget = null;
		this._SelectedAthlete = null;
		super._initFields(settings);
		this._Mode = 'FullHeight';
		this._Caption = NP.RM.getString('FighterStatWidget');
		this._CloseOnFrameMouseDown = true;
		this._ShowHeader = true;
		this._ShowCloseButton = true;
		this._OkRK = 'Save'
		this._AutoDestroy = true;
		this._Width = 1600;
	}

	_render()
	{
		super._render();

		let flexNode = NP.createNode(this._contentNode, 'widget-dlg-content-node')
		let leftNode = NP.createNode(flexNode, 'widget-dlg-settings-node')
		this._contentDomNode.style.maxWidth = '1600px'

		this._name = new TextField({
			FloatingLabel: NP.RM.getString('Name'),
			ParentNode: leftNode
		});

		this._selectFighter = new SelectFighterCtrl({
			ParentNode: leftNode,
			FloatingLabel: NP.RM.getString('Athlete'),
			EvSelected: () => this.onSettingsChanged()
		})

		this._fighterNameInput = new TextField({
			FloatingLabel: NP.RM.getString('WidgetAthleteName'),
			ParentNode: leftNode,
			EvChanging: () => this.onSettingsChanged()
		});

		this._periodType = new Select({
			FloatingLabel: NP.RM.getString('PeriodType'),
			ParentNode: leftNode,
			Items: [
				{RK: 'All', Value: 'All'},
				{RK: 'LastYear', Value: 'LastYear'},
				{RK: 'Event', Value: 'Event'}
			],
			Value: 'All',
			EvItemSelected: () =>
			{
				switch (this._periodType.getValue())
				{
					case 'LastYear':
					case 'All':
						this._tournamentCombo.setIsVisible(false);
						this._eventCombo.setIsVisible(false)
						break;
					case 'Event':
						this._tournamentCombo.setIsVisible(true);
						this._eventCombo.setIsVisible(true)
						break
				}

				this.onSettingsChanged();
			}
		})

		this._tournamentCombo = new Select({
			ParentNode: leftNode,
			FloatingLabel: NP.RM.getString('Tournament'),
			EvItemSelected: () => this.updateEvents()
		});

		this._eventCombo = new Select({
			ParentNode: leftNode,
			FloatingLabel: NP.RM.getString('Event'),
			EvItemSelected: () => this.onSettingsChanged()
		});


		this._backgoundUrlInput = new TextField({
			FloatingLabel: NP.RM.getString('Background'),
			ParentNode: leftNode,
			EvChanging: () => this.onSettingsChanged()
		});

		this._fontCombo = new Select({
			ParentNode: leftNode,
			Value: 'Muller',
			Items: [
				{Content: 'Muller', Value: 'Muller'},
				{Content: 'Roboto', Value: 'Roboto'},
				{Content: 'Corbert', Value: 'Corbert'},
				{Content: 'Bourgeois', Value: 'Bourgeois'},
				{Content: 'Swis', Value: 'Swis721 Blk BT'},
				{Content: 'PF Din Text Comp Pro', Value: 'PF Din Text Comp Pro'}
			],
			FloatingLabel: NP.RM.getString('FontFamily'),
			EvItemSelected: () => this.onSettingsChanged()
		});

		this._fontColor = new ColorPicker({
			ParentNode: leftNode,
			FloatingLabel: NP.RM.getString('FontColor'),
			EvColorChanged: () => this.onSettingsChanged()
		})

		this._photoUrlInput = new TextField({
			FloatingLabel: NP.RM.getString('PhotoUrl'),
			ParentNode: leftNode,
			EvChanging: () => this.onSettingsChanged()
		});

		this._leftTopLogoUrlInput = new TextField({
			FloatingLabel: NP.RM.getString('LogoLeftTop'),
			ParentNode: leftNode,
			EvChanging: () => this.onSettingsChanged()
		});

		this._logoRightBottomLogoUrlInput = new TextField({
			FloatingLabel: NP.RM.getString('LogoRightBottom'),
			ParentNode: leftNode,
			EvChanging: () => this.onSettingsChanged()
		});


		this._previewFrame = NP.createNode(flexNode, '', 'iframe');

		if (this._Widget)
		{
			this._selectFighter.setValue(this._Widget.Metadata.FighterId)
			this._name.setValue(this._Widget.Name)
			this._fighterNameInput.setValue(this._Widget.Metadata.FighterName)
			this._photoUrlInput.setValue(this._Widget.Metadata.PhotoUrl)
			this._backgoundUrlInput.setValue(this._Widget.Metadata.Background)
			this._leftTopLogoUrlInput.setValue(this._Widget.Metadata.LogoLeftTop)
			this._logoRightBottomLogoUrlInput.setValue(this._Widget.Metadata.LogoRightBottom);
			this._fontColor.setValue(this._Widget.Metadata.FontColor || 'black')

			this._fontCombo.setValue(this._Widget.Metadata.FontFamily || 'Muller')

			if (this._Widget.Metadata.PeriodType)
			{
				this._periodType.setValue('LastYear')
			}
			else if (this._Widget.Metadata.EventId)
			{
				this._periodType.setValue('Event')
			}
			else
			{
				this._periodType.setValue('All')
			}
		}
		else
		{
			if (this._SelectedAthlete)
			{
				this._selectFighter.setValue(this._SelectedAthlete.Id)
				this._name.setValue("Fighter stat " + this._SelectedAthlete.LastName)
			}
			this._periodType.setValue('All')
		}

		if (!this._Widget)
			this._Widget = {
				Metadata: {WId: WidgetType.FighterStat}
			} as Widget<FighterStatWidgetMetadata>

		this.refresh()
	}

	onSettingsChanged()
	{
		if (this._timeId)
			clearTimeout(this._timeId);

		this._timeId = setTimeout(() => this.updatePreview(), 200);
	}

	updateObjSettings()
	{
		this._Widget.Name = this._name.getValue()
		this._Widget.Metadata.FighterId = this._selectFighter.getValue();
		this._Widget.Metadata.FighterName = this._fighterNameInput.getValue()
		this._Widget.Metadata.PhotoUrl = this._photoUrlInput.getValue()
		this._Widget.Metadata.Background = this._backgoundUrlInput.getValue()
		this._Widget.Metadata.LogoLeftTop = this._leftTopLogoUrlInput.getValue()
		this._Widget.Metadata.LogoRightBottom = this._logoRightBottomLogoUrlInput.getValue()
		this._Widget.Metadata.FontFamily = this._fontCombo.getValue()

		this._Widget.Metadata.FontColor = this._fontColor.getValue()

		switch (this._periodType.getValue())
		{
			case 'LastYear':
				this._Widget.Metadata.LastN = 1;
				this._Widget.Metadata.PeriodType = "LastYear";
				this._Widget.Metadata.EventId = null;
				break;
			case 'All':
				this._Widget.Metadata.EventId = null;
				this._Widget.Metadata.LastN = 0;
				this._Widget.Metadata.PeriodType = "";
				break;
			case 'Event':
				this._Widget.Metadata.LastN = 0;
				this._Widget.Metadata.PeriodType = "";
				this._Widget.Metadata.EventId = this._eventCombo.getValue();
				break
		}
	}

	updatePreview()
	{
		this.updateObjSettings();

		if (this._Widget.Metadata.FighterId)
			this._previewFrame.src = `/cwidget/fighter-stat?id=${this._Widget.Id || -1}&lang=${NP.getCurrentCulture().Name}&json=${encodeURIComponent(JSON.stringify(this._Widget))}`
	}

	async refresh()
	{

		let tList = await getTournaments(SportType.MMA) as ITournament[]


		let items = tList.map(t => ({Value: t.Id, FontImage: NP.FontImages.integration, Content: t.Name, Data: t}));
		this._tournamentCombo.setItems(items);


		if (this._Widget && this._Widget.Metadata.EventId)
		{
			let ev = await ServerAPI.get<EventTournament>(`/t-events/${this._Widget.Metadata.EventId}`)
			if (ev)
			{
				this._tournamentCombo.setValue(ev.TournamentId)
				await this.updateEvents(ev.TournamentId);
				this._eventCombo.setValue(this._Widget.Metadata.EventId, false);
				this.updatePreview()
			}
		}
		else
		{
			if (tList[0])
			{
				this._tournamentCombo.setValue(tList[0].Id)
				this.updateEvents();
			}
		}
	}

	async updateEvents(tId: number = null)
	{
		let response = await ServerAPI.post("/t-events", {
			Count: 500,
			Offset: 0,
			TournamentId: tId || this._tournamentCombo.getValue()
		}) as { List: EventTournament[], AllCount: number };
		this._tEvents = response.List;
		this._eventCombo.setItems(response.List.map(ev => ({Content: ev.Name, Value: ev.Id})));
	}


	async _onOkButtonClick()
	{
		this.updateObjSettings();

		if (this._Widget.Id)
			await ServerAPI.callUiApi(`/widget/${this._Widget.Id}`, this._Widget, 'POST');
		else
			await ServerAPI.callUiApi("/widget", this._Widget, 'PUT')


		this.EvOkButtonClick.fire(this);
		this.hide();
	}
}